export enum HIAssemblyState {
    BatteryInsertion = 'batteryInsertion',
    ClickSleeveSelection = 'clickSleeveSelection',
}
